/**
 * Learning Service — API client for coordination pattern library and analysis history.
 *
 * All calls go to the PhD API (REACT_APP_PHD_API_URL).
 */

const PHD_API_BASE = process.env.REACT_APP_PHD_API_URL || 'http://localhost:5002';

async function learningFetch(endpoint) {
    const response = await fetch(`${PHD_API_BASE}${endpoint}`, {
        headers: { 'Content-Type': 'application/json' },
    });
    const data = await response.json();
    if (!response.ok) {
        throw new Error(data.error || data.message || `HTTP ${response.status}: ${response.statusText}`);
    }
    return data;
}

/**
 * Get all coordination patterns from the pattern library.
 * @returns {Promise<{patterns: Array}>}
 */
export async function getPatterns() {
    return learningFetch('/api/coordination/patterns');
}

/**
 * Get recent scenario analyses from benchmark runs.
 * @param {number} limit - Max number of analyses to return
 * @returns {Promise<{analyses: Array}>}
 */
export async function getAnalyses(limit = 20) {
    return learningFetch(`/api/coordination/analyses?limit=${limit}`);
}
